import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Layout, Menu, MenuProps } from 'antd'

import { MENU_LIST } from '@/constants'
import { useLeftDrawer, useNavigation } from '@/hooks'

const { Sider } = Layout

export const LeftDrawer = () => {
  const { t, i18n } = useTranslation()
  const navigation = useNavigation()
  const { isHidden } = useLeftDrawer()

  const menuList = useMemo(
    () =>
      MENU_LIST.map((item) => ({
        ...item,
        label: t(item.label, ''),
      })),
    [MENU_LIST, i18n.language],
  )

  const onMenuItemClick: MenuProps['onClick'] = (e) => {
    const path = e.keyPath.reverse().join('/')
    navigation.goTo(path)
  }

  return (
    <Sider trigger={null} collapsible collapsed={isHidden}>
      <Menu
        mode="inline"
        className="h-screen bg-white"
        defaultSelectedKeys={['overview']}
        items={menuList}
        onClick={onMenuItemClick}
      />
    </Sider>
  )
}
